import { Box, Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';

import { SIDEKICK_TRANSLATION_NAMESPACE } from '../../translations';
import useStyles from './PanelPlaceholder.styles';

/**
 * Empty-state body for the Sidekick panel, rendered when the
 * consumer does not supply its own `children`. Resolves copy against
 * the package's own translation namespace.
 */
function PanelPlaceholder() {
  const { classes } = useStyles();
  const { t } = useTranslation(SIDEKICK_TRANSLATION_NAMESPACE);

  return (
    <Box
      className={classes.container}
      data-testid="ai-sidekick-panel-placeholder"
    >
      <Typography className={classes.text} component="p">
        {t('panel.placeholder')}
      </Typography>
    </Box>
  );
}

export default PanelPlaceholder;
